export default "<div class=\"logo\">\n    <img src=\"/assets/img/page-not-found.png\" width=\"200\" height=\"200\" alt=\"CRM Taracoe\">\n</div>\n"